module.exports = __webpack_public_path__ + "img/tour-22.1f1a9553.png";